module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['progress-bar', 'progress-bar-' + _vm.type, {
      active: _vm.animated,
      'progress-bar-striped': _vm.striped
    }],
    style: ({
      width: _vm.nowNum + '%'
    }),
    domProps: {
      "textContent": _vm._s(_vm.labelBool ? _vm.nowNum + '%' : null)
    }
  })
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1abcb87c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1abcb87c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Progressbar.vue
// module id = 147
// module chunks = 0